<script lang="ts">
    import {getInjector} from 'src/core';
    import type {SutorHomePageData} from './types';
    import {exists} from 'shared/utils/custom-utils';
    import {onMount} from 'svelte';
    import {HomepageService} from './homepage.service';
    import SutorHomepageNotificationsPart from './parts/SutorHomepageNotificationsPart.svelte';
    import SutorHomeWelcomePart from './parts/SutorHomeWelcomePart.svelte';
    import ErpPageLayout from '../../../erp/components/ErpPageLayout.svelte';
    import SutorHomeCardsPart from './parts/SutorHomeCardsPart.svelte';

    const service = getInjector().getByClass(HomepageService);

    let homepageData: SutorHomePageData;
    let loading = true;
    $: loadError = !exists(homepageData) && !loading;

    onMount(async () => {
        try {
            homepageData = await service.getHomePageData();
        } finally {
            loading = false;
        }
    });
</script>

<ErpPageLayout pageClass="sutor-landing-page"
               dontCollapseSidebar
               {loading}
               {loadError}>

    <SutorHomeWelcomePart slot="heading" let:auth user={auth.activeUser}/>

    <svelte:fragment>
        <SutorHomepageNotificationsPart/>
        <SutorHomeCardsPart {homepageData}/>
    </svelte:fragment>
</ErpPageLayout>

<style lang="less">
    @import (reference) "styles/portaro-erp.less";

    :global {
        sutor-landing-page {
            .flex-grow();
        }
    }
</style>